import { render, staticRenderFns } from "./DomainEditSuccessModal.vue?vue&type=template&id=a6bfa6c6&scoped=true"
import script from "./DomainEditSuccessModal.vue?vue&type=script&lang=js"
export * from "./DomainEditSuccessModal.vue?vue&type=script&lang=js"
import style0 from "./DomainEditSuccessModal.vue?vue&type=style&index=0&id=a6bfa6c6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6bfa6c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/workspace/Control-Panel/Control-Panel-Preprod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6bfa6c6')) {
      api.createRecord('a6bfa6c6', component.options)
    } else {
      api.reload('a6bfa6c6', component.options)
    }
    module.hot.accept("./DomainEditSuccessModal.vue?vue&type=template&id=a6bfa6c6&scoped=true", function () {
      api.rerender('a6bfa6c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DomainActivation/DomainEditModal/DomainEditSuccessModal.vue"
export default component.exports